module.exports = __webpack_public_path__ + "static/human-b9552cb6c1ed2b51c956f1683dc517df.jpg";